module.exports = __webpack_public_path__ + "static/media/ikea-family.9fb46b69.jpg";